export class FeatureFlags {
    public static readonly PasswordExpiryNotification: string = "8994_PasswordExpiryNotification";
    public static readonly TodayDashboard = "11395_TodaysDashboard";
    public static readonly KPI = "11394_KPI";
    public static readonly RescheduleNotifications = "11396_RescheduleNotifications";
    public static readonly CalendarFullAppointmentStatus = "13027_CalendarFullAppointmentStatus";
    public static readonly PasswordSecurity = "13034_PasswordSecurity";
}
